import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useDispatch } from "react-redux";
import { connectUser } from "../../store/Store";

export default function Signup({ onLogin }) {
  axios.defaults.baseURL = process.env.REACT_APP_API_API;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [identifier, setIdentifier] = useState("");
  const [lastName, setLastName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const toggleShowPassword = () => setShowPassword(v => !v);

  const handleSignup = () => {
    if (!identifier || !lastName || !firstName || !email || !password) {
      setErrorMessage("Merci de remplir tous les champs obligatoires.");
      return;
    }
    if (password !== confirmPassword) {
      setErrorMessage("Les mots de passe ne correspondent pas.");
      return;
    }

    axios
      .post("/api/v1/user/signup", {
        identifier,
        email,
        lastName,
        firstName,
        password,
      })
      .then((response) => {
        const user = response.data;
        if (user.message === "Registration failed") {
          setErrorMessage("Inscription refusée. Vérifiez vos informations.");
        } else if (user.message === "Registration success") {
          dispatch(
            connectUser({
              id: user.id,
              firstName: user.firstName,
              darkMode: user.darkMode,
              applications: user.applications,
            })
          );
          onLogin?.();
          navigate("/home");
          setErrorMessage(null);
        } else {
          setErrorMessage("Réponse inattendue du serveur.");
        }
      })
      .catch((error) => {
        if (error.response) {
          setErrorMessage(
            error.response.data?.message ||
              "Une erreur est survenue lors de l'inscription."
          );
        } else if (error.request) {
          setErrorMessage("Aucune réponse du serveur.");
        } else {
          setErrorMessage("Erreur inconnue : " + error.message);
        }
      });
  };

  const onKeyDown = (e) => {
    if (e.key === "Enter") handleSignup();
  };

  return (
    <>
      <h2 className="arena-title">Créer un compte</h2>

      <label className="arena-label" htmlFor="identifier">Identifiant</label>
      <input
        id="identifier"
        type="text"
        placeholder="Identifiant"
        value={identifier}
        onChange={(e) => setIdentifier(e.target.value)}
        onKeyDown={onKeyDown}
        className="arena-input"
        autoComplete="username"
      />

      <label className="arena-label" htmlFor="lastName">Nom</label>
      <input
        id="lastName"
        type="text"
        placeholder="Nom"
        value={lastName}
        onChange={(e) => setLastName(e.target.value)}
        onKeyDown={onKeyDown}
        className="arena-input"
        autoComplete="family-name"
      />

      <label className="arena-label" htmlFor="firstName">Prénom</label>
      <input
        id="firstName"
        type="text"
        placeholder="Prénom"
        value={firstName}
        onChange={(e) => setFirstName(e.target.value)}
        onKeyDown={onKeyDown}
        className="arena-input"
        autoComplete="given-name"
      />

      <label className="arena-label" htmlFor="email">Adresse e-mail</label>
      <input
        id="email"
        type="email"
        placeholder="vous@club.com"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        onKeyDown={onKeyDown}
        className="arena-input"
        autoComplete="email"
      />

      <label className="arena-label" htmlFor="password">Mot de passe</label>
      <div className="arena-password">
        <input
          id="password"
          type={showPassword ? "text" : "password"}
          placeholder="Mot de passe"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={onKeyDown}
          className="arena-input"
          autoComplete="new-password"
        />
        <button
          type="button"
          className="arena-eye"
          aria-label={showPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}
          onClick={toggleShowPassword}
        >
          {showPassword ? "👁️" : "👁️‍🗨️"}
        </button>
      </div>

      <label className="arena-label" htmlFor="confirmPassword">Confirmer le mot de passe</label>
      <input
        id="confirmPassword"
        type={showPassword ? "text" : "password"}
        placeholder="Confirmez le mot de passe"
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
        onKeyDown={onKeyDown}
        className="arena-input"
        autoComplete="new-password"
      />

      {errorMessage && <p className="arena-error">{errorMessage}</p>}

      <button className="arena-primary" onClick={handleSignup}>
        S'inscrire
      </button>
    </>
  );
}